import { render, staticRenderFns } from "./DvFilterPopover.vue?vue&type=template&id=352ef9bf&scoped=true&"
import script from "./DvFilterPopover.vue?vue&type=script&lang=ts&"
export * from "./DvFilterPopover.vue?vue&type=script&lang=ts&"
import style0 from "./DvFilterPopover.vue?vue&type=style&index=0&id=352ef9bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ef9bf",
  null
  
)

export default component.exports